import { darken } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../ui';
import { Checkbox } from '../../packages/controls/Checkbox';
import { aspect } from './Aspect';
import { RenderTextField } from './RenderField';
import { RenderBorder, RenderBounds } from './RenderHelpers';
import { VisualBase } from './VisualBase';

export class CheckboxVisual extends VisualBase<Checkbox> {

    @aspect()
    private get borderStyling(): any {
        return {
            width: this.object.width,
            height: this.object.height,
            // border: this.border,
            // borderRadius: '4px',
            // boxShadow: !!this.object.background ? '0 1px 2px 0 rgba(0,0,0,.05)' : '',
        };
    }

    @aspect()
    private get valueBorder() {
        const { selected, targeted, pressed, beingEdited } = this.pose;
        if (beingEdited) return `solid 2px ${Colors.primary}`;
        if (!selected && pressed) return `solid 2px ${Colors.primaryDark}`;
        if (!selected && targeted) return `solid 2px ${Colors.primary}`;
        return `solid 2px ${darken(.15, '#fff')}`;
    }

    @aspect()
    private get valueStyle(): any {
        const { value } = this.object.layout;
        return {
            left: `${value.left}px`,
            top: `${value.top}px`,
            width: `${value.width}px`,
            height: `${value.height}px`,
            backgroundColor: this.object.background,
            border: this.valueBorder,
            borderRadius: '4px',
            boxShadow: !!this.object.background ? '0 1px 2px 0 rgba(0,0,0,.05)' : '',
        };
    }

    public render() {
        return <>
            <RenderBounds object={this.object}>
                <RenderValue style={this.valueStyle}>
                    {!this.object.value &&
                        <svg viewBox="0 0 24 24">
                            <path d="M5 13L9 17L19 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }
                </RenderValue>
                <RenderBorder pose={this.pose} style={this.borderStyling}>
                    {!this.isBeingEdited && <RenderTextField object={this.object} name="text" />}
                </RenderBorder>
            </RenderBounds>
        </>;
    }
}

const RenderValue = styled.div`
    position: absolute;
    border: solid 2px gainsboro;
    border-radius: 2px;

    svg {
        position: absolute;
        inset: 0;
    }
`;